/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiMultipleResult,
    ApiResult,
    DeviceInvitationDto,
    DeviceInvitationRequest,
    DeviceOwnerDto,
} from "../models/index";
import {
    ApiMultipleResultFromJSON,
    ApiMultipleResultToJSON,
    ApiResultFromJSON,
    ApiResultToJSON,
    DeviceInvitationDtoFromJSON,
    DeviceInvitationDtoToJSON,
    DeviceInvitationRequestFromJSON,
    DeviceInvitationRequestToJSON,
    DeviceOwnerDtoFromJSON,
    DeviceOwnerDtoToJSON,
} from "../models/index";

export interface CreateDeviceInvitationRequest {
    body?: DeviceInvitationRequest;
}

export interface DeviceOwnerDetailRequest {
    deviceOwnerId: number;
}

export interface DeviceOwnerDetailByDeviceIdRequest {
    deviceIdentity: string;
    deviceArchiveId?: number;
}

export interface DeviceOwnerDetailsInsertRequest {
    body?: DeviceOwnerDto;
}

export interface DeviceOwnerDetailsUpdateRequest {
    body?: DeviceOwnerDto;
}

export interface DeviceOwnerRemoveRequest {
    deviceOwnerId: number;
}

export interface DeviceOwnerUserAccountVerificationRequest {
    deviceOwnerId: number;
    userAccountId?: number;
}

export interface SetDeviceOwnerRequest {
    deviceIdentity: string;
    deviceArchiveId?: number;
    deviceOwnerId?: number;
    cascadeToChildDevices?: boolean;
}

/**
 *
 */
export class DeviceOwnerHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Create an invitation code to one or more devices, to be accepted by EndUser(s).
     */
    async createDeviceInvitationRaw(
        requestParameters: CreateDeviceInvitationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceinvitations/create`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceInvitationRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create an invitation code to one or more devices, to be accepted by EndUser(s).
     */
    async createDeviceInvitation(
        requestParameters: CreateDeviceInvitationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createDeviceInvitationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * All Device Invitations OData (IlluminateAdmin users only)
     */
    async deviceInvitationsODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceInvitationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceinvitations-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceInvitationDtoFromJSON),
        );
    }

    /**
     * All Device Invitations OData (IlluminateAdmin users only)
     */
    async deviceInvitationsOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceInvitationDto>> {
        const response = await this.deviceInvitationsODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * DeviceOwner details by deviceOwnerId. IlluminateAdmin users only. To get a owner\'s devices, use /devices?deviceOwnerId=x
     */
    async deviceOwnerDetailRaw(
        requestParameters: DeviceOwnerDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceOwnerDto>> {
        if (requestParameters["deviceOwnerId"] == null) {
            throw new runtime.RequiredError(
                "deviceOwnerId",
                'Required parameter "deviceOwnerId" was null or undefined when calling deviceOwnerDetail().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceowners/{deviceOwnerId}`.replace(
                    `{${"deviceOwnerId"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceOwnerId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceOwnerDtoFromJSON(jsonValue),
        );
    }

    /**
     * DeviceOwner details by deviceOwnerId. IlluminateAdmin users only. To get a owner\'s devices, use /devices?deviceOwnerId=x
     */
    async deviceOwnerDetail(
        requestParameters: DeviceOwnerDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceOwnerDto> {
        const response = await this.deviceOwnerDetailRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * DeviceOwner details by device identity. IlluminateAdmin users only.
     */
    async deviceOwnerDetailByDeviceIdRaw(
        requestParameters: DeviceOwnerDetailByDeviceIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceOwnerDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceOwnerDetailByDeviceId().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceArchiveId"] != null) {
            queryParameters["deviceArchiveId"] =
                requestParameters["deviceArchiveId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/deviceowner`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceOwnerDtoFromJSON(jsonValue),
        );
    }

    /**
     * DeviceOwner details by device identity. IlluminateAdmin users only.
     */
    async deviceOwnerDetailByDeviceId(
        requestParameters: DeviceOwnerDetailByDeviceIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceOwnerDto> {
        const response = await this.deviceOwnerDetailByDeviceIdRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert new DeviceOwner (customer) details. Admins may set all DeviceOwner columns.
     */
    async deviceOwnerDetailsInsertRaw(
        requestParameters: DeviceOwnerDetailsInsertRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceowners/insert`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceOwnerDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert new DeviceOwner (customer) details. Admins may set all DeviceOwner columns.
     */
    async deviceOwnerDetailsInsert(
        requestParameters: DeviceOwnerDetailsInsertRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceOwnerDetailsInsertRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update DeviceOwner (customer) details. Admins may update all DeviceOwner columns.
     */
    async deviceOwnerDetailsUpdateRaw(
        requestParameters: DeviceOwnerDetailsUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceowners/update`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceOwnerDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update DeviceOwner (customer) details. Admins may update all DeviceOwner columns.
     */
    async deviceOwnerDetailsUpdate(
        requestParameters: DeviceOwnerDetailsUpdateRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceOwnerDetailsUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Removes the DeviceOwner if no linked devices are found.
     */
    async deviceOwnerRemoveRaw(
        requestParameters: DeviceOwnerRemoveRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["deviceOwnerId"] == null) {
            throw new runtime.RequiredError(
                "deviceOwnerId",
                'Required parameter "deviceOwnerId" was null or undefined when calling deviceOwnerRemove().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceowners/{deviceOwnerId}`.replace(
                    `{${"deviceOwnerId"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceOwnerId"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Removes the DeviceOwner if no linked devices are found.
     */
    async deviceOwnerRemove(
        requestParameters: DeviceOwnerRemoveRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.deviceOwnerRemoveRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Link a user account to a DeviceOwner (DeviceOwner.OwnerUserAccount), and give the account access to all devices owned by this owner. If the DeviceOwner already has a owner account linked, removes all access from that account to the devices it owned. If a new userAccountId is not provided, the DeviceOwner no longer has any owner accounts, so no EndUser will have Owner access. All pending invites from this DeviceOwner are also removed.
     */
    async deviceOwnerUserAccountVerificationRaw(
        requestParameters: DeviceOwnerUserAccountVerificationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceOwnerId"] == null) {
            throw new runtime.RequiredError(
                "deviceOwnerId",
                'Required parameter "deviceOwnerId" was null or undefined when calling deviceOwnerUserAccountVerification().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["userAccountId"] != null) {
            queryParameters["userAccountId"] =
                requestParameters["userAccountId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceowners/{deviceOwnerId}/useraccount-verification`.replace(
                    `{${"deviceOwnerId"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceOwnerId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Link a user account to a DeviceOwner (DeviceOwner.OwnerUserAccount), and give the account access to all devices owned by this owner. If the DeviceOwner already has a owner account linked, removes all access from that account to the devices it owned. If a new userAccountId is not provided, the DeviceOwner no longer has any owner accounts, so no EndUser will have Owner access. All pending invites from this DeviceOwner are also removed.
     */
    async deviceOwnerUserAccountVerification(
        requestParameters: DeviceOwnerUserAccountVerificationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceOwnerUserAccountVerificationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * All Device Owners OData (IlluminateAdmin users only)
     */
    async deviceOwnersODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceOwnerDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/deviceowners-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceOwnerDtoFromJSON),
        );
    }

    /**
     * All Device Owners OData (IlluminateAdmin users only)
     */
    async deviceOwnersOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceOwnerDto>> {
        const response = await this.deviceOwnersODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set or clear a device\'s owner. Requires system_device_provisioning
     */
    async setDeviceOwnerRaw(
        requestParameters: SetDeviceOwnerRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling setDeviceOwner().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceArchiveId"] != null) {
            queryParameters["deviceArchiveId"] =
                requestParameters["deviceArchiveId"];
        }

        if (requestParameters["deviceOwnerId"] != null) {
            queryParameters["deviceOwnerId"] =
                requestParameters["deviceOwnerId"];
        }

        if (requestParameters["cascadeToChildDevices"] != null) {
            queryParameters["cascadeToChildDevices"] =
                requestParameters["cascadeToChildDevices"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/deviceowner`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Set or clear a device\'s owner. Requires system_device_provisioning
     */
    async setDeviceOwner(
        requestParameters: SetDeviceOwnerRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.setDeviceOwnerRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
